import React, { useState, Suspense } from 'react'
import styles from './styles.module.css'
import { AiTwotoneAppstore, AiOutlineAppstore, AiOutlineClose } from 'react-icons/ai'
import { FaTicketAlt, FaSignOutAlt, FaReceipt } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import logo from '../../assets/logo.png'
import { CircularProgress } from '@chakra-ui/react'
import { userLogout } from '../../redux/actions/user/authActions'

const Navigation = () => {
    const dispatch = useDispatch()
    const [mtoggle, setMToggle] = useState(false)

    const logoutHandler = () => {
        dispatch(userLogout())
    }
    return (
        <Suspense fallback={CircularProgress}>
            <div className={styles.bar}>{mtoggle ? <AiOutlineClose onClick={() => setMToggle(false)} /> : <AiOutlineAppstore onClick={() => setMToggle(true)} />}</div>
            <div className={mtoggle ? styles.navMobile : styles.navigation}>
                <div className={styles.logo}>
                    <img src={logo} alt="company logo" />
                    <h3>Helpdesk</h3>
                </div>
                {/* <div className={styles.name}>
                    <h5>Hello {user.fullName}!</h5>
                </div> */}
                <div className={styles.url}>
                    <ul>
                        <Link to="/user/dashboard">
                            <li><AiTwotoneAppstore />Dashboard</li>
                        </Link>
                        <Link to="/user/tickets/create">
                            <li><FaTicketAlt />Create Ticket</li>
                        </Link>

                        <Link to="/user/tickets">
                            <li><FaReceipt />My Tickets</li>
                        </Link>

                        <Link to="/#" onClick={logoutHandler}>
                            <li><FaSignOutAlt />Logout</li>
                        </Link>
                    </ul>
                </div>
            </div>
        </Suspense>
    )
}

export default Navigation